// internal-deps
import { AnalyticsContextValue } from "@swiggy-private/checkout-core";

// constants
import { SCREEN_NAME, CLICK_ACTIONS, IMPRESSION_ACTIONS } from "../constants";
import { IIrctcPayload } from "@swiggy-private/cart-types";

export const impressionAddressWidgetTop = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    irctcData?: IIrctcPayload,
    slaMessage?: string,
): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: IMPRESSION_ACTIONS.IMPRESSION_ADDRESS_WIDGET_TOP,
        context: irctcData
            ? JSON.stringify({ deliveryStation: irctcData.station_name, slaMessage: slaMessage })
            : undefined,
        //eslint-disable-next-line @typescript-eslint/naming-convention
        extraParams: (irctcData && JSON.stringify({ is_irctc_event: true })) || "",
    });
};

export const impressionAddressPSLABanner = ({
    impressionEvent,
    delayMessage,
    cartId,
    originalCartId,
}: {
    impressionEvent: AnalyticsContextValue["impressionEvent"];
    delayMessage?: string;
    cartId?: number;
    originalCartId?: number;
}): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: IMPRESSION_ACTIONS.IMPRESSION_ADDRESS_PSLA_BANNER,
        context: JSON.stringify({ message: delayMessage, cartId, originalCartId }),
    });
};

export const impressionCartHeader = (impressionEvent: AnalyticsContextValue["impressionEvent"]): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: IMPRESSION_ACTIONS.IMPRESSION_CART_HEADER,
    });
};

export const clickAddressWidgetTop = (clickEvent: AnalyticsContextValue["clickEvent"], context: string): void => {
    clickEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: CLICK_ACTIONS.CLICK_ADDRESS_WIDGET_TOP,
        context,
    });
};

export const clickCartHeaderDropdown = (clickEvent: AnalyticsContextValue["clickEvent"]): void => {
    clickEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: CLICK_ACTIONS.CLICK_CART_HEADER_DROPDOWN,
    });
};
